module.exports = __webpack_public_path__ + "static/media/road-show-2.e7bfd9c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/RoadShowPage/assets/road-show-2.png
// module id = 539
// module chunks = 0